const menu = {
    label: 'Expresso',
    icon: 'pi pi-fw pi-id-card',
    to: '/integrape/expresso',
    rules: ['EXPR-ATEN-00', 'EXPR-PAIN-00', 'EXPR-SALA-00'],
};

export default menu;
